import { businessKey } from 'queryKeys';

export const SPEND_ADJUSMENT = 'sa';
export const LOGS = 'logs';

const saQuery = businessKey.query(SPEND_ADJUSMENT);

export const grids = saQuery.grids();
export const grid = saQuery.grid();

export const details = saQuery.details();
export const model = saQuery.exact();
export const logs = saQuery.next(LOGS);

export const mutations = saQuery.mutations();

export const approve = mutations.approve();
export const create = mutations.create();
export const deleteSA = mutations.delete();
export const reject = mutations.reject();
export const undo = mutations.undo();
export const update = mutations.update();

const MUTATION_MORE_INFO = 'moreInfo';
const EXPORT_SPEND_ADJUSTMENTS = 'exportSpendAdjustments';
const IMPORT_SA = 'exportSpendAdjustments';
const IMPORT_SA_BY_CAMPAIGNS = 'exportSpendAdjustments';

const CHECK_SPEND_ADJUSTMENTS = 'checkSpendAdjustment';
export const importSA = mutations.mutate(IMPORT_SA);
export const importSAByCampaigns = mutations.mutate(IMPORT_SA_BY_CAMPAIGNS);
export const check = mutations.mutate(CHECK_SPEND_ADJUSTMENTS);
export const exportGrid = mutations.mutate(EXPORT_SPEND_ADJUSTMENTS);
export const moreInfo = mutations.mutate(MUTATION_MORE_INFO);
